<template>
  <el-select v-model="listQuery.name" placeholder="请选择盘组名称" size="mini" @change="changeName">
    <el-option
      v-for="item in options"
      :key="item.name"
      :label="item.name"
      :value="item.name"
    >
    </el-option>
  </el-select>
</template>

<script>
import { zyDeviceList  } from "@/api/ea";
export default {
    data(){
        return{
            options:[],
            listQuery:{
                name:undefined
            }
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            zyDeviceList().then(res=>{
                this.options = res.data.data.list
            })
        },
        changeName(){
            this.$emit('onLoading',true)
            this.$emit('success', this.listQuery.name)
        },
        // getList(){
        //     console.log(this.listQuery.name);
        //     zyTaxDiscList(this.listQuery).then(res=>{
        //         console.log(res);
        //     })
        // }
    }
}
</script>

<style>

</style>